<div class="slc-card-outlet">
  <ng-container cdkPortalOutlet> </ng-container>
</div>

<ng-template #content>
  <div class="card h-full slc-card-content">
    @if (dmController && card()) {
    <!-- -->
    @if (card()?.tipo === tipoCard.LISTA) {
    <app-dashboard-card-list
      [card]="card()!"
      [dmController]="dmController"
      [origemDados]="origemDados"
      (origemDadosChange)="onOrigemDadosChanged($event)"
      [fullScreenHabilitado]="fullScreenHabilitado"
      (alternarFullscreen)="alternarFullscreen()"
    ></app-dashboard-card-list>
    }
    <!-- -->
    @else {
    <app-dashboard-card-chart
      [card]="card()!"
      [dmController]="dmController"
      [origemDados]="origemDados"
      (origemDadosChange)="onOrigemDadosChanged($event)"
      [fullScreenHabilitado]="fullScreenHabilitado"
      (alternarFullscreen)="alternarFullscreen()"
    ></app-dashboard-card-chart>
    } }
    <ng-content></ng-content>
  </div>
</ng-template>
